import { Component } from '@angular/core';

@Component({
  selector: 'app-cards1-examples-6',
  templateUrl: './cards1-examples-6.component.html'
})
export class Cards1Examples6Component {}
